module.exports = __webpack_public_path__ + "img/bt-2-off.02e7f0db.png";